import { DateUtil } from "utilities/date-utilities";
import RoomTypeView from "../roomType/RoomTypeView";
import { AvailabilityRoomType } from "./AvailabilityTable";
import * as lodash from 'lodash';
import BooleanView from "components/common/views/BooleanView";

type AvailableRoomTypeCountViewPropsType = {
    data: AvailabilityRoomType[],
    selectedDates?: Date[],
    roomCount: number,
}

const AvailableRoomTypeCountView = (props: AvailableRoomTypeCountViewPropsType) => {
    if(!props.selectedDates?.length) return <></>;
    let roomTypes: {id: number, color?: string | null, name: string}[] = [];
    const avData = props.selectedDates!.map(d => {
        return lodash.unionBy(props.data, x => x.roomType.id).map(room => {
            const roomType = room.roomType;
            if(!roomTypes.some(x => x.id === roomType.id)) {
                roomTypes.push(roomType);
            }
            const thisTypeRooms = props.data.filter(x => x.roomType.id === roomType.id);
            const totalRoomCount = thisTypeRooms.length;
            let reservedRooms = 0;
            thisTypeRooms.forEach(r => {
                if(r.bookingDetails.some(x => DateUtil.compareOnAsIsoDate(x.date, d))) {
                    reservedRooms++;
                }
            });
            return {
                roomTypeName: roomType.name,
                color: roomType.color,
                roomTypeId: roomType.id,
                available: totalRoomCount - (reservedRooms + (props.roomCount - 1)) > 0,
            }
        });
    }).flat();

    return <>
        {roomTypes.map(roomType => {
            const av = avData.some(x => x.roomTypeId === roomType.id && !x.available);
            return <span key={`available-room-count-${roomType.id}}`} className="border-l theme-border first:border-transparent px-2 text-xl">
                <RoomTypeView name={roomType.name[0]} color={roomType.color} /> 
                <BooleanView value={!av} />
            </span>
        })}
    </>
};

export default AvailableRoomTypeCountView;
